import data from '../../assets/json/config.json';

export class ContentHelper {
  static getContent(page: string) {
    return data[page];
  }

  static getBadge() {
    return data['config']['badges'];
  }

  static getBadgeAlt() {
    return data['config']['badgeAlts'];
  }

  static getName() {
    return data['config']['name'];
  }

  static getContentItemsPath() {
    return data['config']['contentItemsPath'];
  }

  static getTipsPath() {
    return data['config']['tipsPath'];
  }
}